import styled from "styled-components";

export const ChatFooterInputGroup = styled.div<{ isValid: boolean }>`
  ${(props) => props?.theme?.themeConfig?.chatFooter?.inputGroup?.styles}

  border-color: ${(props) => props.isValid ? "" : 'rgb(239, 68, 68)'};
`
